import axios from 'axios';

const BASE_URL_OKX = 'https://api.piscan.io';

const api = axios.create({
  baseURL: BASE_URL_OKX,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const okx = {
  getMarketData: async () => {
    try {
      const response = await api.get(`/data/pi-price`);
      return response.data.data[0];
    } catch (error) {
      console.error('Error fetching market data:', error);
      // Return default data
      return {
        idxPx: "2.0", // Default price 
        high24h: "2.0",
        open24h: "2.0"
      };
    }
  }
};
